<template>
  <div class="m-0 dbozone-font bg-blessingtiger" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-blessingtiger">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -blessingtiger`">{{ $t('blessingtiger.name') }}
          </h5>
        </section>
      </div>

      <div>
        <h3 class="m-0 text-bold pt-5 pb-3">{{ $t('blessingtiger.gamerule') }}</h3>
      </div>
      <div class="d-flex p-2 mt-1" v-for="(text, index) in textList" :key="'textList' + index">
        <div v-if="index === 0">
          <div v-if="lang === 'zh'" class="">
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </div>
          <div v-else class="">
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </div>
        </div>
        <div v-else>
          <span v-if="index === 1" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}</span>
          <span v-else-if="index === 2" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}</span>
          <span v-else-if="index === 3" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) + baseBet +
            $t('blessingtiger.text-rule5') }} </span>
          <span v-else-if="index === 4" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) +
            currencyFormatterWithSymbol(betSize[0])
            + $t('info.to') + currencyFormatterWithSymbol(betSize[betSize.length - 1]) + $t('blessingtiger.text-rule7')
            + betLevel[0] + $t('info.to') + betLevel[betLevel.length - 1] + $t('blessingtiger.text-rule8') }} </span>
          <span v-else-if="index === 5" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) + currency + `(` +
            formattedCurrency + `)` }}</span>
          <span v-else-if="index > 5" class="m-0 text-sub p-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div>
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.round') }}</h3>
      </div>

      <div class="d-flex p-2 mt-1 pb-3" v-for="(text, index) in roundList" :key="'roundList' + index">
        <div>
          <span v-if="index === 0" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 1" class="m-0 text-bold" :class="`-${lang}`">{{ $t('blessingtiger.round-title1')
          }}</span>
          <span v-if="index === 1" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 2" class="m-0 text-bold" :class="`-${lang}`">{{ $t('blessingtiger.round-title2')
          }}</span>
          <span v-if="index === 2" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 3" class="m-0 text-bold" :class="`-${lang}`">{{ $t('blessingtiger.round-title3')
          }}</span>
          <span v-if="index === 3" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 4" class="m-0 text-bold" :class="`-${lang}`">{{ $t('blessingtiger.round-title4')
          }}</span>
          <span v-if="index === 4" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <div v-if="index === 5" class="m-0 text-bold" :class="`-${lang}`">{{ $t('blessingtiger.round-title5')
          }}</div>
          <span v-if="index === 5" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 6" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 7" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 8" class="m-0 text-bold" :class="`-${lang}`">{{ $t('blessingtiger.round-title6')
          }}</span>
          <span v-if="index === 8" class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>
      <div>
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.payout-rules') }}</h3>
      </div>
      <div class="pt-5">
        <span class="m-0 text-bold ">{{ $t('blessingtiger.ways-to-win') }}</span>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.ways-to-win1') }}</div>
      </div>

      <div class="pt-5">
        <span class="m-0 text-bold ">{{ $t('blessingtiger.payouts') }}</span>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.payouts1') }}</div>
      </div>

      <div class="pt-5">
        <span class="m-0 text-bold ">{{ $t('blessingtiger.cascading-wins') }}</span>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.cascading-wins1') }}</div>
      </div>

      <div class="pt-5">
        <span class="m-0 text-bold ">{{ $t('blessingtiger.multiplier-for-regular-game') }}</span>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.multiplier-for-regular-game1') }}</div>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.multiplier-for-regular-game2') }}</div>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.multiplier-for-regular-game3') }}</div>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-way" :src="require(`../../assets/ruleGames/blessingtiger/rule_bet.png`)" alt="">
      </div>
      <div class="pt-5">
        <span class="m-0 text-sub ">{{ $t('blessingtiger.bet-size') }}</span>
      </div>

      <div class="pt-5">
        <span class="m-0 text-bold ">{{ $t('blessingtiger.payout-cal') }}</span>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.payout-cal1') }}</div>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.payout-cal2') }}</div>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.payout-cal3') }}</div>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.payout-cal4') }}</div>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.payout-cal5') }}</div>
      </div>



      <div>
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.paytable') }}</h3>
      </div>
      <div>
        <span class="m-0 text-sub ">{{ $t('blessingtiger.paytable-des') }}</span>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_7.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[7][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[7][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[7][2] / baseBet) }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_6.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[6][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[6][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[6][2] / baseBet) }}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_5.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[5][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[5][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[5][2] / baseBet) }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_4.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[4][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[4][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[4][2] / baseBet) }}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_3.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[3][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[3][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[3][2] / baseBet) }}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_2.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[2][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[2][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[2][2] / baseBet) }}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-left d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_1.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[1][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[1][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[1][2] / baseBet) }}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/blessingtiger/symbol_0.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[0][4] / baseBet) }}
            <br>{{ '4 - ' + decimalFormat(currentBet * paytable[0][3] / baseBet) }}
            <br>{{ '3 - ' + decimalFormat(currentBet * paytable[0][2] / baseBet) }}
          </span>
        </div>
      </div>

      <div class="pt-2">
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.adjustment') }}</h3>
      </div>
      <div>
        <span class="m-0 text-sub ">{{ $t('blessingtiger.adjustment-des') }}</span>
      </div>

      <div class="pt-5">
        <span class="m-0 text-bold ">{{ $t('blessingtiger.note') }}</span>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.note-des1') }}</div>
        <div class="m-0 text-sub ">{{ $t('blessingtiger.note-des2') }}</div>
      </div>

      <div class="pt-2">
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.goldframe') }}</h3>
      </div>

      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-symbol" :src="require(`../../assets/paytable/blessingtiger/way.png`)" alt="">
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in goldframeList" :key="'goldframeList' + index">
        <div>
          <span class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-2">
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.wildsymbol') }}</h3>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in wildList" :key="'wildList' + index">
        <div>
          <span v-if="index === 0" class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}
            <div class="d-flex p-2 mt-1 justify-content-center">
              <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/blessingtiger/symbol_9.png`)" alt="">
            </div>
          </span>
          <span v-else-if="index === 3">
            <span class="m-0 text-bold pl-4" :class="`-${lang}`">{{ $t('blessingtiger.wild-example') }}</span>
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index === 4">
            <span class="m-0 text-bold pl-4" :class="`-${lang}`">{{ $t('blessingtiger.wild-note') }}</span>
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-2">
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.multipliers') }}</h3>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in multipliersList" :key="'multipliersList' + index">
        <div>
          <span v-if="index === 0">
            <div class="d-flex p-2 mt-1 justify-content-center">
              <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/blessingtiger/multiplier.png`)"
                alt="">
            </div>
            <span class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index === 4">
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-2">
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.freespin') }}</h3>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in freespinFeatureList" :key="'freespinFeatureList' + index">
        <div>
          <span v-if="index === 0">
            <div class="d-flex p-2 mt-1 justify-content-center">
              <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/blessingtiger/symbol_8.png`)" alt="">
              <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/blessingtiger/symbol_8.png`)" alt="">
              <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/blessingtiger/symbol_8.png`)" alt="">
            </div>
            <span class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index > 4">
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-2">
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.buyfreespin') }}</h3>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in buyfreespinList" :key="'buyfreespinList' + index">
        <div>
          <span v-if="index === 0">
            <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
              <img class="mt-3 icon-way"
                :src="require(`../../assets/paytable/blessingtiger/feature_buy_${imgLang}.png`)" alt="">
            </div>
            <span class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index === 4" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text)
            + currencyFormatterWithSymbol(betSize[0] * betLevel[0] * 20)
            + $t('blessingtiger.buyfreespin-des6') + currencyFormatterWithSymbol(featureBuyMaximum)
          }}</span>
          <span v-else-if="index === 5" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text)
            + currencyFormatterWithSymbol(featureBuyMaximum) +
            $t('blessingtiger.buyfreespin-des8')
          }}</span>
          <span v-else class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-2">
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('blessingtiger.way') }}</h3>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in wayList" :key="'wayList' + index">
        <div>
          <span v-if="index === 1">
            <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
              <img class="mt-3 icon-way" :src="require(`../../assets/paytable/blessingtiger/line_paytable.png`)" alt="">
            </div>
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-2">
        <h3 class="m-0 text-title-bold pt-5 pb-3">{{ $t('main-game.title') }}</h3>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-spin" :src="require(`../../assets/ruleGames/blessingtiger/spin_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.spin') }}</span>
          <div v-for="(text, index) in spinList" :key="'spinList' + index">
            <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</div>
          </div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/blessingtiger/stop_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <div class="m-0 text-sub pl-4\" :class="`-${lang}`">{{ $t('main-game.autospin-rounds-desc1') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/blessingtiger/minus_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.minus') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-minus') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/blessingtiger/plus_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.plus') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-plus') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/blessingtiger/autospin_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.autospin') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto1') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto2') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto4') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto5') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto6') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/blessingtiger/menu_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.additional') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.additional-des') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/wallet_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.wallet') }}</span>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.wallet-des1') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.wallet-des2') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/refresh_icon.png`)" alt="">
        <div class="m-0 pl-3 ">
          <span class="m-0 text-bold">{{ $t('main-game.refresh') }}</span>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.refresh-des') }}</span>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/betamount_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.bet-amount') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.bet-amount-des1') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.bet-amount-des2') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.bet-amount-des3') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/win_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.winning') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.winning-des1') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.winning-des2') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 pl--5 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/quit_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.quit') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-quit') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/info_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.pay-info') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-info') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/history_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.history') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-history') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/option_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.sound-settings') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.sound-settings-desc1') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-close" :src="require(`../../assets/ruleGames/main/close_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.close') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-close') }}</div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>

export default {
  name: 'rule-blessingtiger',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    currency: String,
    featureBuyMaximum: Number,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      textList: [
        'blessingtiger.text-rule1',
        'blessingtiger.text-rule2',
        'blessingtiger.text-rule3',
        'blessingtiger.text-rule4',
        'blessingtiger.text-rule6',
        'blessingtiger.text-rule9',
        'blessingtiger.text-rule10',
        'blessingtiger.text-rule11',
        'blessingtiger.text-rule12',
        'blessingtiger.text-rule13',
        'blessingtiger.text-rule14',
        'blessingtiger.text-rule15',
        'blessingtiger.text-rule16',
        'blessingtiger.text-rule17',
        'blessingtiger.text-rule18',
      ],
      roundList: [
        'blessingtiger.round-des',
        'blessingtiger.round-des1',
        'blessingtiger.round-des2',
        'blessingtiger.round-des3',
        'blessingtiger.round-des4',
        'blessingtiger.round-des5',
        'blessingtiger.round-des6',
        'blessingtiger.round-des7',
        'blessingtiger.round-des8',

      ],
      goldframeList: [
        'blessingtiger.goldframe-desc1',
        'blessingtiger.goldframe-desc2',
        'blessingtiger.goldframe-desc3',
        'blessingtiger.goldframe-desc4',
        'blessingtiger.goldframe-desc5',
      ],
      wildList: [
        'blessingtiger.wildsymbol-desc1',
        'blessingtiger.wildsymbol-desc2',
        'blessingtiger.wildsymbol-desc3',
        'blessingtiger.wildsymbol-desc4',
        'blessingtiger.wildsymbol-desc5',
      ],
      multipliersList: [
        'blessingtiger.multipliers-des1',
        'blessingtiger.multipliers-des2',
        'blessingtiger.multipliers-des3',
        'blessingtiger.multipliers-des4',
        'blessingtiger.multipliers-des5',
      ],
      freespinFeatureList: [
        'blessingtiger.freespin-des1',
        'blessingtiger.freespin-des2',
        'blessingtiger.freespin-des3',
        'blessingtiger.freespin-des4',
        'blessingtiger.freespin-des5',
        'blessingtiger.freespin-des6',
        'blessingtiger.freespin-des7',
      ],
      buyfreespinList: [
        'blessingtiger.buyfreespin-des1',
        'blessingtiger.buyfreespin-des2',
        'blessingtiger.buyfreespin-des3',
        'blessingtiger.buyfreespin-des4',
        'blessingtiger.buyfreespin-des5',
        'blessingtiger.buyfreespin-des7',
        'blessingtiger.buyfreespin-des9',
      ],
      wayList: [
        'blessingtiger.way-des1',
        'blessingtiger.way-des2',
      ],
      spinList: [
        'main-game.spin-des1',
        'main-game.spin-des2',
        'main-game.spin-des3',
        'main-game.spin-des4',
        'main-game.spin-des5',
      ],

      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable,
    }
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    },
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      if (this.isShowCurrencySymbol === false) {
        this.currency = '';
      }
      return this.$options.filters.currencyFormatterWithSymbol(val, this.currency);
    },
    decimalFormat(val) {
      return this.$options.filters.decimalFormat(val);
    }
  }
}
</script>

<style>
.bg-blessingtiger {
  background: #391818;
}

.nav-blessingtiger {
  background: #A90000;
  border-radius: 50px;
}

.text-title.-blessingtiger {
  color: #fff;
}

.text-title-bold {
  color: white;
  text-align: left;
  font-size: 5vw;
  font-weight: bold;
}

.text-bold {
  color: white;
  text-align: left;
  font-size: 4vw;
  font-weight: bold;
}

.icon-info {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}

.icon-spin {
  width: 30%;
  height: 30%;
  margin-right: 10px;
}

.icon-menu {
  width: 15%;
  height: 15%;
  margin-right: 10px;
}

.icon-close {
  width: 12%;
  height: 12%;
  margin-right: 10px;
}

.icon-refresh {
  width: 120px;
  height: 120px;
  padding-left: -20px;
}

.icon-way {
  width: 90%;
  height: 90%;
}

.icon-symbol {
  width: 25vw
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 920px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}
</style>